import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { IContractorDeductionTemplate } from "../getContractorDeductionTemplates/getContractorDeductionTemplates";

export interface IUpdateContractorDeductionTemplateRequest {
  companyID: string;
  deductionTemplateID: string;
  effective_end_date?: string;
  effective_start_date?: string;
  custom_name?: string;
  agency_address?: string;
  agency_name?: string;
  case_id?: string;
  order_number?: string;
  employee_contribution_amount?: number;
  employee_contribution_percentage?: number;
  employer_contribution_amount?: number;
  employer_contribution_percentage?: number;
  deduction_credit?: boolean;
  external_id?: string;
}

export const updateContractorDeductionTemplate = (axios: IAxiosInstance) => {
  return async (
    params: IUpdateContractorDeductionTemplateRequest
  ): Promise<IContractorDeductionTemplate> => {
    const { deductionTemplateID, ...body } = params;
    const response = await axios.noRetry.patch<
      IApiResponse<IContractorDeductionTemplate>
    >(`/api/contractor-deduction-templates/${deductionTemplateID}`, body);
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to update contractor deduction template");
  };
};
